import React from 'react'

const EditEventFormPrintType = ({dataKey, nameKey, headline, eventData, form_settings}) => {
    const id = eventData[dataKey]
    const name = form_settings[dataKey].items[id][nameKey]

    if(name) {
        return (
            <div className="container-1-2  margin-bottom">
                <span className="text-regular">{headline}:</span> 
                <span className="text-small-light">{name}</span>
            </div>
        )
    } else {
        return ''
    }
}

export default EditEventFormPrintType